import ACTION_TYPES from './actionTypes';

export const reducer = (state, action) => {
    switch (action.type) {
        case ACTION_TYPES.TOGGLE_LOADING:
            return {
                ...state,
                loading: action.loading
            };
        case ACTION_TYPES.GIGS_TRANSLATED:
            return {
                ...state,
                ...action.payload
            };
        case ACTION_TYPES.FILTER_APPLIED:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    active: action.active,
                    selected: action.selected
                }
            };
        case ACTION_TYPES.SC_FILTER_APPLIED:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    subCategory: {
                        ...state.filter.subCategory,
                        headAsLink: true,
                        children: action.children
                    }
                }
            };
        default:
            return state;
    }
};
